import { useSearchParams } from 'react-router-dom';

export default function PaymentFailPage() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  const token = searchParams.get('token');
  const baseUrl = window.location.origin;

  return (
    <main className="min-h-screen flex items-center justify-center bg-cream-50 py-16">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-6">
          <i className="ri-close-line text-3xl text-red-600" />
        </div>
        <h1 className="text-2xl font-bold text-charcoal-900 mb-3">فشل الدفع</h1>
        {orderId && <p className="text-charcoal-500 mb-1 text-sm">رقم الطلب: <span className="font-mono font-bold">{orderId}</span></p>}
        <p className="text-charcoal-600 mb-6 text-sm">عذراً، حدث خطأ أثناء عملية الدفع. يرجى المحاولة مرة أخرى.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {token && <a href={`${baseUrl}/payment/${token}`} className="btn-primary text-center text-sm">المحاولة مرة أخرى</a>}
          <a href={`${baseUrl}/shop`} className="btn-outline text-center text-sm">العودة للمتجر</a>
        </div>
      </div>
    </main>
  );
}
